import React, {} from 'react'
import {Redirect} from 'react-router-dom'

const Alba = () => <Redirect to={'/alba/reservation'}/>;

export default Alba;
